import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/common/shared/shared.module';
import { ProjectManagementComponent } from './project-management.component';
import { FilterPopupComponent } from './filter-popup/filter-popup.component';

@NgModule({
  declarations: [
    ProjectManagementComponent,
    FilterPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule
  ],
  exports: [
    ProjectManagementComponent,
    FilterPopupComponent
  ]
})
export class ProjectManagementModule { }